<template>
  <v-card :color="room.edited ? 'primary' : 'blue-grey lighten-4'" class="white--text text-center roomholder" :dark="dark">
    <v-card-title primary-title class="text-center">
      <div class="icon">
        <v-icon large color="white">{{room.type.icon}}</v-icon>
      </div>
      <span class="room-type">{{room.type.name}}</span>
      <h2 class="headline" v-if="room.name">{{room.name}}</h2>
      <h2 class="headline" v-else>{{room.type.name}}</h2>
    </v-card-title>
    <v-card-actions>
      <v-btn flat :dark="dark" @click="editRoom">{{editText}}</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat color="red" @click="deleteRoom">Slett</v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
export default {
  props: ["room", "index", "editText"],
  mounted: function() {},
  methods: {
    updateMessage(e) {
      this.$emit("update-fields");
    },
    deleteRoom() {
      this.$emit("delete-room", this.index);
    },
    editRoom() {
      this.edited = true;
      this.$emit("edit-room", this.room);
    }
  },
  computed: {
    dark: {
      get() {
        if (this.$store.state.fields.dark) {
          return this.$store.state.fields.dark;
        }
        return false;
      }
    }    
  }
};
</script>

<style scoped>
.headline {
  width: 100%;
}
.room-type {
  width: 100%;
  margin-bottom: 8px;
}
.icon {
  text-align: center;
  width: 100%;
}
</style>